module.exports = __webpack_public_path__ + "img/new_index_cases_bg.c049c547.jpg";